import { FormHelperText } from "@material-ui/core";
import Accordion from "@material-ui/core/Accordion";
import AccordionActions from "@material-ui/core/AccordionActions";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import CssBaseline from "@material-ui/core/CssBaseline";
import Divider from "@material-ui/core/Divider";
import Fab from "@material-ui/core/Fab";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import DeleteIcon from "@material-ui/icons/Delete";
import SaveIcon from "@material-ui/icons/Save";
import clsx from "clsx";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  addStoreAction,
  deleteStoreAction,
} from "../../../../store/store/actions";
import { getSessionData } from "../../base/helper/baseHelper";
import Base from "../../base/views/base";
import SelectableSearch from "../../base/views/SelectableSearch";
import LandingPageFooter from "../../LandingPage/views/LandingPageFooter";
import {
  GetCityDropDownData,
  GetCountryDropDownData,
  GetStateDropDownData,
  GetZipDetails,
} from "../../SignUp/helper/signUpHelper";
import { getPlans } from "../helper/subscriptionHelper";

const EMAIL_REGEX = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
const LANDLINE_REGEX = /^[+\d](?:.*\d)?$/;

const useStyles = makeStyles((theme) => ({
  Appcss: {
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(6px)",
    borderRadius: "15px",
    padding: "10px",
    marginTop: "20px",
    paddingTop: "20px",
    justifyContent: "center",
    alignItems: "center",
  },
  root: {
    width: "100%",
    "& .MuiPaper-root": {
      backgroundColor: "rgba(255,255,255,0.5)",
      backdropFilter: "blur(6px)",
      borderRadius: "15px",
      padding: "10px",
      marginTop: "1%",
      justifyContent: "center",
      alignItems: "center",
    },
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  icon: {
    verticalAlign: "bottom",
    height: 20,
    width: 20,
  },
  details: {
    alignItems: "center",
  },
  column: {
    flexBasis: "50%",
    alignSelf: "flex-start",
  },
  helper: {
    paddingLeft: theme.spacing(2),
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    marginTop: theme.spacing(3),
    paddingTop: theme.spacing(1),
  },
  form: {
    width: "100%", // Fix IE 11 issue.
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  margin: {
    margin: theme.spacing(1),
  },
  formControl: {
    margin: 0,
    fullWidth: true,
    display: "flex",
    wrap: "nowrap",
  },
}));

const storeObj = {
  id: 1,
  storeName: "",
  email: "",
  storeAlias: "",
  storeTaxNumber: "",
  storeLandline: "+1",
  street1: "",
  street2: "",
  country: { id: 0, optionname: "" },
  state: { id: 0, optionname: "" },
  city: { id: 0, optionname: "" },
  zip: "",
  plan: "",
  isExpanded: true,
};

function PurchaseSubscription(props) {
  const classes = useStyles();
  const [storeList, setStoreList] = useState([storeObj]);
  const [errors, setErrors] = useState([]);
  // eslint-disable-next-line
  const [users, setusers] = useState(3);
  const [countryData, setCountryData] = useState({
    load: false,
    values: [],
  });
  const [stateData, setStateData] = useState({
    load: false,
    values: [],
  });
  const [cityData, setCityData] = useState({
    load: false,
    values: [],
  });
  const [userId, setUserId] = useState("");
  const [plans, setPlans] = useState([]);
  const { addStore } = props;

  useEffect(() => {
    getPlans().then((res) => {
      setPlans([...res.data]);
    });
  }, []);

  useEffect(() => {
    setUserId(getSessionData({ key: "userId" }));
  }, [userId]);

  useEffect(() => {
    return () => {};
  }, []);

  function updateZipField(event, index) {
    let newArr = [...storeList];
    let item = newArr[index];
    const zipcode = event.target.value;
    item = { ...item, zip: zipcode };
    var params = { zipcode };
    const obj = item;
    newArr[index] = obj;
    setStoreList(newArr);
    if (zipcode.length < 5) return;

    GetZipDetails(params).then((response) => {
      if (response && response.length) {
        var countryResponse = {
          id: response[0].country_id,
          optionname: response[0].country_name,
        };
        var stateResponse = {
          id: response[0].state_id,
          optionname: response[0].state_name,
        };
        var cityResponse = {
          id: response[0].city_id,
          optionname: response[0].city_name,
        };
        obj.country = countryResponse;
        obj.state = stateResponse;
        obj.city = cityResponse;
      } else {
        obj.country = { id: 0, optionname: "" };
        obj.state = { id: 0, optionname: "" };
        obj.city = { id: 0, optionname: "" };
      }
      const updatedArr = [...newArr];
      updatedArr[index] = obj;
      setStoreList(updatedArr);
    });
  }

  function handleChange(event, index) {
    let newArr = [...storeList];
    let item = newArr[index];
    item = { ...item, [event.target.name]: event.target.value };
    newArr[index] = item;
    setStoreList(newArr);
  }
  const HandleExpanded = (event, index) => {
    let newArr = storeList;
    newArr[index].isExpanded = !newArr[index].isExpanded;
    setStoreList([...newArr]);
  };

  const setUsersinputValue = (e) => {
    var val = e.target.value === "" ? null : parseInt(e.target.value);
    if (val > 500) {
      setusers(500);
    }
    if (val === null) {
      setusers(0);
    }
    if (val < 0) {
      setusers(0);
    } else setusers(val);
  };

  const loadingCountry = () => {
    setCountryData({ ...countryData, load: true });
    GetCountryDropDownData()
      .then((response) => {
        setCountryData({ load: false, values: response });
      })
      .catch((err) => {});
  };

  const loadingState = (countryId = 0) => {
    setStateData({ ...stateData, load: true });
    var params = { country_id: countryId };
    GetStateDropDownData(params)
      .then((response) => {
        setStateData({ load: false, values: response });
      })
      .catch((err) => {});
  };

  const loadingCity = (stateId = 0) => {
    setCityData({ ...cityData, load: true });
    var params = { state_id: stateId };
    GetCityDropDownData(params)
      .then((response) => {
        setCityData({ load: false, values: response });
      })
      .catch((err) => {});
  };

  const handleCountryChange = (event, value) => {
    if (value && value.id) {
      const list = storeList;
      const index = /_([\d]+)/.exec(event.target.id)[1];
      if (index) {
        list[index].country = { id: value.id, optionname: value.optionname };
        list[index].state = {};
        list[index].city = {};
        setStoreList(list);
      }
    }
    setStateData({ ...stateData, values: [] });
    setCityData({ ...cityData, values: [] });
  };
  const handleStateChange = (event, value) => {
    setCityData({ ...cityData, values: [] });
    if (value && value.id) {
      const list = storeList;
      const index = /_([\d]+)/.exec(event.target.id)[1];
      if (index) {
        list[index].state = {
          id: value.id,
          optionname: value.optionname,
        };
        list[index].city = {};
        setStoreList(list);
      }
    }
  };

  const handleCityChange = (event, value) => {
    if (value && value.id) {
      const list = storeList;
      const index = /_([\d]+)/.exec(event.target.id)[1];
      if (index) {
        list[index].city = { id: value.id, optionname: value.optionname };
        setStoreList(list);
      }
    }
  };

  const validate = (store, index) => {
    const error = {};
    if (!store.storeName) error.storeName = "Pharmacy Name is required";
    if (!store.storeAlias) error.storeAlias = "Pharmacy Alias is required";
    if (!store.storeTaxNumber)
      error.storeTaxNumber = "Pharmacy Tax Number is required";
    if (!store.street1) error.street1 = "Street1 is required";
    if (!store.country.optionname) error.country = "Country is required";
    if (!store.city.optionname) error.city = "City is required";
    if (!store.state.optionname) error.state = "State is required";
    if (!store.zip) error.zip = "Zip is required";
    if (!store.plan) error.plan = "Plan is required";
    if (store.email && !EMAIL_REGEX.test(store.email))
      error.email = "Please enter a valid email";
    const temp = errors;
    temp[index] = error;
    setErrors([...temp]);
    return Object.values(error).every((e) => e === "");
  };

  const handleSaveStore = async (e, i) => {
    e.preventDefault();
    const store = storeList[i];
    if (validate(store, i)) {
      const { hasError } = await addStore({ ...store, userId });
      if (hasError) return;
      let newArr = [...storeList];
      newArr[i] = storeObj;
      setStoreList(newArr);
    }
  };

  const onRemoveStore = (e, index) => {
    if (storeList && storeList.length > 1) {
      const list = [...storeList];
      list.splice(index, 1);
      if (list !== null && list.length === 1) {
        list[0].isExpanded = true;
      }
      setStoreList([...list]);
    }
  };
  return (
    <div style={{ display: "flex" }}>
      <Base hideDrawer={true} showBaseMenu={false} hidePharmacyButton={true}>
        <Container component="main" maxWidth="lg">
          <CssBaseline />
          {storeList.map((store, i) => (
            <div key={i}>
              <div className={classes.paper}>
                <Accordion
                  className={classes.Appcss}
                  expanded={store.isExpanded}
                  onChange={(event) => {
                    HandleExpanded(event, i);
                  }}
                >
                  <div className={classes.column}>
                    <Typography component="h1" variant="h5">
                      Pharmacy
                      {store.storeAlias && " - " + store.storeAlias}
                    </Typography>
                  </div>
                  <AccordionDetails className={classes.details}>
                    <div className={classes.column}>
                      <form className={classes.form} noValidate>
                        <Grid container spacing={2}>
                          <Grid item xs={12}>
                            <TextField
                              inputProps={{ tabIndex: "1" }}
                              id={"storeName_" + store.id}
                              name="storeName"
                              value={store.storeName}
                              autoComplete="sname"
                              variant="outlined"
                              required
                              fullWidth
                              label="Pharmacy Name"
                              autoFocus
                              onChange={(event) => {
                                handleChange(event, i);
                              }}
                              {...(errors[i] &&
                                errors[i].storeName && {
                                  error: true,
                                  helperText: errors[i].storeName,
                                })}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              inputProps={{ tabIndex: "3" }}
                              id={"street1_" + store.id}
                              name="street1"
                              autoComplete="street1"
                              value={store.street1}
                              variant="outlined"
                              required
                              fullWidth
                              label="Street1"
                              onChange={(event) => {
                                handleChange(event, i);
                              }}
                              {...(errors[i] &&
                                errors[i].street1 && {
                                  error: true,
                                  helperText: errors[i].street1,
                                })}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              inputProps={{ tabIndex: "5" }}
                              id={"zip" + store.id}
                              name="zip"
                              autoComplete="zip"
                              value={store.zip}
                              variant="outlined"
                              required
                              fullWidth
                              label="Zip"
                              onChange={(event) => {
                                updateZipField(event, i);
                              }}
                              {...(errors[i] &&
                                errors[i].zip && {
                                  error: true,
                                  helperText: errors[i].zip,
                                })}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <SelectableSearch
                              tabIndex={7}
                              value={store.state}
                              data={stateData}
                              name="state"
                              label="State"
                              id={"state_" + i}
                              loading={() => {
                                loadingState(storeList[i].country.id);
                              }}
                              onChangeEvent={handleStateChange}
                              {...(errors[i] &&
                                errors[i].state && {
                                  error: true,
                                  helperText: errors[i].state,
                                })}
                            ></SelectableSearch>
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              inputProps={{ tabIndex: 9 }}
                              id={"storeLandline" + store.id}
                              name="storeLandline"
                              autoComplete="storeLandline"
                              value={store.storeLandline}
                              variant="outlined"
                              fullWidth
                              label="Pharmacy Landline"
                              onChange={(event) => {
                                if (
                                  event.target.value === "" ||
                                  LANDLINE_REGEX.test(event.target.value)
                                )
                                  handleChange(event, i);
                              }}
                              {...(errors[i] &&
                                errors[i].storeLandline && {
                                  error: true,
                                  helperText: errors[i].storeLandline,
                                })}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              inputProps={{ tabIndex: 11 }}
                              id={"email" + store.id}
                              name="email"
                              autoComplete="email"
                              value={store.email}
                              variant="outlined"
                              fullWidth
                              label="Email"
                              onChange={(event) => {
                                handleChange(event, i);
                              }}
                              {...(errors[i] &&
                                errors[i].email && {
                                  error: true,
                                  helperText: errors[i].email,
                                })}
                            />
                          </Grid>
                        </Grid>
                      </form>
                    </div>
                    <div className={clsx(classes.column, classes.helper)}>
                      <form className={classes.form}>
                        <Grid container spacing={2}>
                          <Grid item xs={12}>
                            <TextField
                              inputProps={{ tabIndex: "2" }}
                              id={"storeAlias" + store.id}
                              name="storeAlias"
                              autoComplete="storeAlias"
                              value={store.storeAlias}
                              variant="outlined"
                              required
                              fullWidth
                              label="Pharmacy Alias"
                              onChange={(event) => {
                                handleChange(event, i);
                              }}
                              {...(errors[i] &&
                                errors[i].storeAlias && {
                                  error: true,
                                  helperText: errors[i].storeAlias,
                                })}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              inputProps={{ tabIndex: "4" }}
                              id={"street2" + store.id}
                              name="street2"
                              autoComplete="storeAlias"
                              value={store.street2}
                              variant="outlined"
                              fullWidth
                              label="Street2"
                              onChange={(event) => {
                                handleChange(event, i);
                              }}
                              {...(errors[i] &&
                                errors[i].street2 && {
                                  error: true,
                                  helperText: errors[i].street2,
                                })}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <SelectableSearch
                              tabIndex={6}
                              value={store.city}
                              data={cityData}
                              name="city"
                              label="City"
                              id={"city_" + i}
                              loading={() => {
                                loadingCity(storeList[i].state.id);
                              }}
                              onChangeEvent={handleCityChange}
                              {...(errors[i] &&
                                errors[i].city && {
                                  error: true,
                                  helperText: errors[i].city,
                                })}
                            ></SelectableSearch>
                          </Grid>
                          <Grid item xs={12}>
                            <SelectableSearch
                              tabIndex={8}
                              value={store.country}
                              data={countryData}
                              name="country"
                              label="Country"
                              id={"country_" + i}
                              loading={loadingCountry}
                              onChangeEvent={handleCountryChange}
                              {...(errors[i] &&
                                errors[i].country && {
                                  error: true,
                                  helperText: errors[i].country,
                                })}
                            ></SelectableSearch>
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              inputProps={{ tabIndex: "10" }}
                              id={"storeTaxNumber" + store.id}
                              name="storeTaxNumber"
                              autoComplete="storeTaxNumber"
                              value={store.storeTaxNumber}
                              variant="outlined"
                              fullWidth
                              label="Pharmacy TaxNumber"
                              onChange={(event) => {
                                handleChange(event, i);
                              }}
                              {...(errors[i] &&
                                errors[i].storeTaxNumber && {
                                  error: true,
                                  helperText: errors[i].storeTaxNumber,
                                })}
                            />
                          </Grid>
                        </Grid>
                      </form>
                    </div>
                  </AccordionDetails>
                  <Divider />
                  <Box
                    component="div"
                    width="100%"
                    style={{ display: "flex", marginRight: "20px" }}
                  >
                    <Box
                      component="div"
                      paddingBottom={1.5}
                      paddingTop={2}
                      paddingLeft={2}
                      width="50%"
                    >
                      <FormControl
                        style={{ display: "flex", marginRight: "20px" }}
                        variant="outlined"
                        className={classes.formControl}
                        {...(errors[i] &&
                          errors[i].plan && {
                            error: true,
                          })}
                      >
                        <InputLabel id="planlabel">Plan</InputLabel>
                        <Select
                          inputProps={{ tabIndex: "11" }}
                          labelId="planlabel"
                          name="plan"
                          id="panselectoutlined"
                          label="Plan"
                          value={store.plan}
                          onChange={(e) => handleChange(e, i)}
                        >
                          <MenuItem value="">
                            <em>None</em>
                          </MenuItem>
                          {plans.map((plan) => (
                            <MenuItem key={plan.planid} value={plan.planid}>
                              {plan.planname}
                            </MenuItem>
                          ))}
                        </Select>
                        <FormHelperText>
                          {errors[i] && errors[i].plan}
                        </FormHelperText>
                      </FormControl>
                    </Box>

                    <Box component="div" width="50%">
                      <TextField
                        className={classes.textField}
                        id="userstextfield"
                        label="Users"
                        value={3}
                        onChange={setUsersinputValue}
                        type="number"
                        InputLabelProps={{ shrink: true }}
                        margin="normal"
                        disabled
                      />
                      <AccordionActions>
                        <Fab
                          size="small"
                          color="primary"
                          aria-label="add"
                          className={classes.margin}
                          onClick={(e) => handleSaveStore(e, i)}
                          style={{ backgroundColor: "rgb(22, 177, 255)" }}
                        >
                          <SaveIcon />
                        </Fab>
                        {storeList && storeList.length > 1 && (
                          <Fab
                            id={store.id}
                            onClick={(e) => {
                              onRemoveStore(e, i);
                            }}
                            size="small"
                            color="secondary"
                            aria-label="delete"
                            className={classes.margin}
                          >
                            <DeleteIcon />
                          </Fab>
                        )}
                      </AccordionActions>
                    </Box>
                  </Box>
                </Accordion>
              </div>
            </div>
          ))}
        </Container>
        <LandingPageFooter />
      </Base>
    </div>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    addStore: async (store) => dispatch(addStoreAction(store)),
    deleteStore: (store) => dispatch(deleteStoreAction(store)),
  };
};

export default connect(null, mapDispatchToProps)(PurchaseSubscription);
